import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { take } from 'rxjs/operators';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { CategoryDescription } from 'app/model/manage-versions/CategoryDescription';
import { AppVersion } from 'app/model/manage-versions/AppVersion';
import { AppsService } from 'app/service/apps/apps.service';
import { GlobalService } from 'app/service/global/global.service';
import { CategoryEnum } from 'app/model/manage-versions/CategoryEnum';
import { PageConfig } from 'app/components/layout/header-nav/header-nav.component';

@Component({
  selector: 'aca-all-versions-info',
  templateUrl: './all-versions-info.component.html',
  styleUrls: ['./all-versions-info.component.scss']
})
export class AllVersionsInfoComponent implements OnInit, AfterViewInit {
  @ViewChild('paginatorFunc') paginatorFunc: MatPaginator;


  bugs: CategoryDescription[] = [];
  melhorias: CategoryDescription[] = [];
  novasFuncionalidades: CategoryDescription[] = [];
  allVersions = new MatTableDataSource<AppVersion>([]);

  pagesConfig: PageConfig[] = [
    {
      title: 'Consultar versões',
      path: ['app-versions-info'],
      icon: 'swap_horiz',
      order: 10,
      isActive: true
    }
  ];

  displayedColumns = ['item'];

  constructor(private appService: AppsService, private globalService: GlobalService) {}

  appImage: string;
  ngOnInit(): void {
    // EventEmitterService.get('$isLogged').emit(true);

    // this.getImage();
    this.onOpenModalVersions();
    this.allVersions.filterPredicate = (data: AppVersion, filter: string) => {
      return JSON.stringify(data).toLowerCase().includes(filter);
    };
  }

  ngAfterViewInit(): void {
    this.allVersions.paginator = this.paginatorFunc;
  }

  hasAnyNewFunc(categoryDescriptions: CategoryDescription[]) {
    return categoryDescriptions.some((detail) => detail.category === CategoryEnum.NOVA_FUNCIONALIDADE);
  }

  hasAnyMelhoria(categoryDescriptions: CategoryDescription[]) {
    return categoryDescriptions.some((detail) => detail.category === CategoryEnum.MELHORIA);
  }

  hasAnyBug(categoryDescriptions: CategoryDescription[]) {
    return categoryDescriptions.some((detail) => detail.category === CategoryEnum.CORRECAO_DE_BUG);
  }

  filter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    console.log(filterValue);
    this.allVersions.filter = filterValue.trim().toLowerCase();
  }

  // getImage() { //TODO: CORRIGIR ISSO
  //   this.alfrescoService.nodesApi.getNodeContent(this.data[0].application.imageId).then(
  //     (res: Blob) => {
  //       // this.appImage = res;
  //       this.appImage = URL.createObjectURL(res);
  //       console.log(this.appImage);

  //       // this.createImageFromBlob();
  //     }
  //   )
  // }

  // fillData(data: AppVersion[]) {
  // data[0].categoryDescriptions
  // this.lastVersion = data.reduce((prev, current) => {
  //   // extrai as propriedades de versão dos objetos
  //   const highestVersion = prev.newVersion;
  //   const currentVersion = current.newVersion;

  //   // usa a função localeCompare() para comparar as versões
  //   return currentVersion.localeCompare(highestVersion) > 0 ? current : prev;
  // });

  // this.bugs = []
  // this.melhorias = []
  // this.novasFuncionalidades = []

  // this.lastVersion.categoryDescriptions.forEach((detail) => {
  //   switch (detail.category) {
  //     case CategoryEnum.CORRECAO_DE_BUG:
  //       this.bugs.push(detail);
  //       break;
  //     case CategoryEnum.MELHORIA:
  //       this.melhorias.push(detail);
  //       break;
  //     case CategoryEnum.NOVA_FUNCIONALIDADE:
  //       this.novasFuncionalidades.push(detail);
  //       break;
  //     default:
  //       break;
  //   }
  // });
  // }

  onOpenModalVersions() {
    this.appService
      .getAppVersionByAppUrl(window.location.origin + '/')
      .pipe(take(1))
      .subscribe((data) => {
        if (!data.result || data.result.length == 0) {
          return this.globalService.openSnackBar('A aplicação não possui versões cadastradas', 'caution');
        }

        // this.fillData(data.result);
        this.allVersions.data = data.result.sort((a, b) => {
          return b.newVersion.localeCompare(a.newVersion);
        });
      });
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/versions/all-versions-info/all-versions-info.component.ts